import React from 'react'
import { PressableProps, TouchableOpacity, View, ViewStyle } from 'react-native'
import { flatten, mergeAll } from 'ramda'

import { Text } from '../text'
import { buttonVariants, textVariants } from './button.variants'
import { ButtonProps } from './button.props'
import { color } from '../../theme'

export function Button(props: ButtonProps) {
  const {
    variant = 'contained',
    tx,
    txOptions,
    text,
    style: styleOverride,
    textStyle: textStyleOverride,
    children,
    disabled = false,
    fullWidth = false,
    round = false,
    subtitleText,
    subtitleTx,
    subtitleTxOptions,
    styleOverrides,
    textStyleOverrides,
    dataSet,
    ...rest
  } = props

  const viewStyle = mergeAll(
    flatten([
      buttonVariants[variant] || buttonVariants.contained,
      fullWidth && { width: '100%' },
      round && { borderRadius: 100 },
      styleOverride,
      disabled && variant === 'text'
        ? {
            backgroundColor: color.transparent,
            border: 'none',
          }
        : disabled && {
            backgroundColor: color.palette.disabled,
            border: 'none',
          },
      styleOverrides,
    ]) as object[],
  )

  const textStyle = mergeAll(
    flatten([
      textVariants[variant] || textVariants.contained,
      textStyleOverride,
      disabled && {
        color: color.palette.disabledText,
      },
      textStyleOverrides,
    ]) as object[],
  )

  const content =
    children ||
    (subtitleText || subtitleTx ? (
      <View style={WITH_SUBTITLE}>
        <Text
          variant={textVariants[variant].variant || textVariants.contained}
          tx={tx}
          txOptions={txOptions}
          text={text}
          style={textStyle}
        />
        <Text
          variant="body2"
          tx={subtitleTx}
          txOptions={subtitleTxOptions}
          text={subtitleText}
          style={textStyle}
        />
      </View>
    ) : (
      <Text
        variant={textVariants[variant].variant || textVariants.contained}
        tx={tx}
        txOptions={txOptions}
        text={text}
        style={textStyle}
      />
    ))

  //   <Pressable
  //   onHoverIn={() => console.log('hover')}
  //   style={viewStyle}
  //   disabled={disabled}
  //   {...rest}
  // >
  //   {content}
  // </Pressable>

  return (
    <TouchableOpacity
      // @ts-ignore
      dataSet={dataSet ? dataSet : { qat: `button-${tx || text}` }}
      style={viewStyle}
      disabled={disabled}
      {...rest}
    >
      {content}
    </TouchableOpacity>
  )
}

const WITH_SUBTITLE: ViewStyle = { display: 'flex', flexDirection: 'column', alignItems: 'center' }
